<template>
   <link type="text/css" rel="stylesheet" href="//fast.fonts.net/cssapi/0f93c4f6-bddb-4cb7-8528-d7dc7a92e401.css"/>
   <div class="nav">
	  <ul class="nav_list_left">
		  <li class="nav_list_left_title">
		  	<span>Swatch Configurator</span>
		  	
		  </li>
		  <li class="nav_list_left_room_select">
		  	<span>Select Area</span>
		  	<ul class="nav_list_sub">
			  	<li v-for="option in roomOptions" v-bind:class="room === option ? 'selected' : '' " @click.prevent="changeRoom(option)"> {{ option | capitalize }} </li>
			  	<!-- <li v-bind:class="room === 'livingarea' ? 'selected' : '' " @click.prevent="changeRoom('livingarea')">Living Area</li> -->
		  	</ul>
		  </li>
		  <li v-bind:class="ifCabinetActive ? 'selected' : '' " @click.prevent="setPopover('cabinet')" class="nav_list_left_simple"><span>Cabinets</span></li>
		  <li v-bind:class="ifFabricActive ? 'selected' : '' " @click.prevent="setPopover('fabrics')" class="nav_list_left_simple"><span>Fabrics</span></li>
	  </ul>	   
	   
      
  </div>
</template>

<script>
export default {
  props : [ 'roomOptions', 'room', 'selected' ],
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      msg: 'Hello World!'
    }
  },
  computed: {
	  ifCabinetActive (){
		  return this.selected === 'cabinet' && this.$parent.popoverOpen  
	  },
	  ifFabricActive (){
		  return this.selected === 'fabrics' && this.$parent.popoverOpen  
	  }
	  
  },
  
  methods: {
    setPopover( value ) {
      this.$dispatch( 'popover-changed', value )
    },
    changeRoom( room ){
	    this.room = room
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->





/** WEBPACK FOOTER **
 ** headerbar.vue?5a9af804
 **/